import { VscInfo } from "react-icons/vsc";
import styled from "styled-components";

import Spacer, { Axis } from "~/components/Spacer";
import { StatusToProcessBlockchainOptions } from "~/endpoints/trustFramework/types";

const LockIconBanner = styled(VscInfo).attrs(() => ({
  width: "22",
  height: "22",
}))`
  font-size: 22px;
  outline: none;
  cursor: pointer;
`;

const Container = styled.section`
  display: flex;
  justify-content: space-between;

  font-weight: 600;
  font-size: 12px;

  align-items: center;
  padding: 16px;
  gap: 10px;
  background: #e3fadf;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px;

  a {
    text-decoration: none;
    color: black;

    &:hover {
      color: grey;
    }
  }
`;

export default function AuthrorisedBlockchainTransactionsBanner({
  statusToProcessBlockchain,
}: {
  statusToProcessBlockchain: StatusToProcessBlockchainOptions;
}) {
  return (
    <Container>
      <div style={{ display: "flex", alignItems: "center" }}>
        <LockIconBanner />

        <Spacer axis={Axis.HORIZONTAL} size={18} />

        <span>
          {statusToProcessBlockchain === StatusToProcessBlockchainOptions.CREATED && (
            <>{"Blockchain transactions are authorized after request is created. "}</>
          )}
          {statusToProcessBlockchain === StatusToProcessBlockchainOptions.SENT && (
            <>{"Blockchain transactions are authorized after request is “Sent” to beneficiary VASP. "}</>
          )}
          {statusToProcessBlockchain === StatusToProcessBlockchainOptions.ACK && (
            <>{"Blockchain transactions are authorized after beneficiary VASP “Confirms” blockchain address. "}</>
          )}
          {statusToProcessBlockchain === StatusToProcessBlockchainOptions.ACCEPTED && (
            <>{"Blockchain transactions are authorized after beneficiary VASP “Accepts” the blockchain transfer. "}</>
          )}
          <a href="/dashboard/settings/automations/authorise-blockchain-transactions" target="_blank" rel="noreferrer">
            View settings
          </a>
        </span>
      </div>
    </Container>
  );
}
